import { AsProps, Box, ChakraProps } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

export type RowProps = {
  space: number;
  children?: ReactNode;
};

const Row = <T extends AsProps, P = Dict>({
  space,
  children,
  ...rest
}: RowProps & ChakraProps & T & P): ReactElement | null => (
  <Box
    {...rest}
    mx={-space}
    sx={{
      ...rest.sx,
      '>*': {
        px: space,
      },
    }}
  >
    {children}
  </Box>
);
export default Row;
